const getLabel = (label) => {
    switch (label) {
        case 'bonus-registration': return 'Бонус за регистрацию';
        case 'bonus-next-deposit': return 'Бонус за следующие депозиты'; 
        case 'bonus-first-deposit': return 'Бонус за первый депозит';
        case 'bonus-promocode': return 'Бонус за прокомоды';
        case 'bonus-personal': return 'Персональный бонус';
        case 'bonus-cashback': return 'Кэшбек по окончанию баланса';
        case 'bonus-everyday': return 'Бонус на каждый день';
        case 'bonus-weekly': return 'Еженедельный бонус';
        case 'bonus-referral': return 'Реферальный бонус';
        case 'bonus-referral-issue': return 'Выдача бонуса за рефералов';
        case 'bonus-tournament': return 'Бонус за выигранный турнир';
        case 'bonus-loterry': return 'Бонус за выигранную лотерею'
        default: return '-'
     }
}

export {
    getLabel
}